// extracted by mini-css-extract-plugin
export default {"cartNumber":"cartHeader_cartNumber__YpuIJ"};